'use client';

import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoOutputWrapper,
  DemoSliderControl,
  DemoRadioControl,
} from '@/components/Demo';
import Paper from '@/components/Paper';

import BeforeAndAfter from './BeforeAndAfter';
import GrabbableLightDemo from './GrabbableLightDemo';
import DesignDistanceDemo from './DesignDistanceDemo';
import LayersDemo from './LayersDemo';
import ShadowMess from './ShadowMess';

const ShadowDemo = ({ variant }) => {
  switch (variant) {
    case 'shadow-mess': {
      return <ShadowMess />;
    }

    case 'before-and-after': {
      return <BeforeAndAfter />;
    }

    case 'grabbable-light': {
      return <GrabbableLightDemo />;
    }

    case 'design-distance': {
      return <DesignDistanceDemo />;
    }

    case 'layers': {
      return (
        <Demo
          id={variant}
          initialValues={{
            reveal: 0,
            enableShadows: true,
          }}
          customGrid={{ gridTemplateColumns: '2fr 1fr' }}
          outputWrapper={LayersOutputWrapper}
          controls={[
            <DemoSliderControl
              key="reveal"
              id="reveal"
              label="Reveal"
              min={0}
              max={100}
              previewRenderer={(v) => `${v}%`}
            />,
            <DemoRadioControl
              key="enableShadows"
              id="enableShadows"
              label="Include Elevation"
              options={[
                { label: 'Yes', value: true },
                { label: 'No', value: false },
              ]}
            />,
          ]}
        >
          {({ reveal, enableShadows }) => {
            return (
              <LayersDemo
                variant={variant}
                reveal={reveal}
                enableShadows={enableShadows}
              />
            );
          }}
        </Demo>
      );
    }

    default: {
      return 'Unrecognized variant';
    }
  }
};

const LayersOutputWrapper = styled(Paper)`
  /* Overwrite the default white/offwhite background: */
  background: transparent !important;
  padding: 48px;

  @media ${BREAKPOINTS.smAndSmaller} {
    padding: 0px;
  }
`;

export default ShadowDemo;
